import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterResource, isInternalLink} from "../../helpers/filters";
import './BioCard.scss';
import {trackEventByUrl} from "../../helpers/events";

interface Data {
    paragraphById: {
        fieldTxtFullName: string;
        fieldTxtJobTitle: string;
        fieldVarLink: Array<{
            uri: string;
            title: string;
        }>;
        fieldImgBioMedia: Array<{
            entity: Array<{
                fieldMediaImage: Array<{
                    width: string;
                    height: string;
                    url: string;
                    targetId: string;
                    alt: string;
                    title: string;
                }>;
            }>;
        }>;
    }
}

class BioCardQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerBioPhoto {
          fieldTxtFullName
          fieldTxtJobTitle
          fieldVarLink {
            uri
            title
          }
          fieldImgBioMedia {
            ... on FieldParagraphFieldImgBioMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

const BioCard = ({id, markComponentLoadedAs}) => (
    <BioCardQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            if (!field.fieldImgBioMedia || !field.fieldImgBioMedia.entity || !field.fieldImgBioMedia.entity.fieldMediaImage || !field.fieldImgBioMedia.entity.fieldMediaImage.url) return null;

            if (field && field.fieldVarLink && field.fieldVarLink.uri) {
                // Add target blank and noopener/noreferrer if the link is external
                const params = {};
                if (!isInternalLink(field.fieldVarLink.uri)) {
                    params.target = '_blank';
                    params.rel = 'noopener noreferrer';
                }

                let eventTitle = 'BioCard';
                if (field.fieldTxtFullName) {
                    eventTitle = field.fieldTxtFullName;
                } else if (field.fieldTxtJobTitle) {
                    eventTitle = field.fieldTxtJobTitle;
                }

                markComponentLoadedAs(id, true);

                return (
                    <a href={field.fieldVarLink.uri} {...params} className="bioCard" onClick={() => trackEventByUrl(field.fieldVarLink.uri, eventTitle)}>

                        <div className="bioCard__image" style={{
                            background: `url("${filterResource(field.fieldImgBioMedia.entity.fieldMediaImage.url)}") no-repeat center center`,
                            backgroundSize: 'cover',
                        }}/>

                        <div className="bioCard__inner">
                            {field.fieldTxtFullName && (
                                <h4 className="bioCard__name">{field.fieldTxtFullName}</h4>
                            )}
                            {field.fieldTxtJobTitle && (
                                <p className="bioCard__title">{field.fieldTxtJobTitle}</p>
                            )}
                        </div>

                    </a>
                );
            }

            markComponentLoadedAs(id, true);

            return (
                <div className="bioCard">

                    <div className="bioCard__image" style={{
                        background: `url("${filterResource(field.fieldImgBioMedia.entity.fieldMediaImage.url)}") no-repeat center center`,
                        backgroundSize: 'cover',
                    }}/>

                    <div className="bioCard__inner">
                        {field.fieldTxtFullName && (
                            <h4 className="bioCard__name">{field.fieldTxtFullName}</h4>
                        )}
                        {field.fieldTxtJobTitle && (
                            <p className="bioCard__title">{field.fieldTxtJobTitle}</p>
                        )}
                    </div>
                </div>
            );
        }}
    </BioCardQuery>
);

BioCard.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default BioCard;



// WEBPACK FOOTER //
// ./frontend/components/BioCards/BioCard.jsx